<template>
  <div class="w-full h-full bg-login absolute top-0 left-0 flex flex-col md:flex-row items-center justify-center">
    <div class="md:order-2 w-full md:w-1/2 xl:w-1/3 p-2 md:p-8 relative max-w-sm md:max-w-full" style="min-height:260px">
      <div>
        <h2 class="text-4xl text-white font-bold">
          Defina su nueva contraseña
        </h2>
        <span class="h-1 bg-secondary w-20 inline-block" />
        <p class="text-lg mt-2 text-primary-100">Por sus seguridad le pedimos que la escriba dos veces para evitar posibles errores.</p>
      </div>
    </div>
    <div class="md:order-1 w-full md:w-1/2 xl:w-1/3 max-w-sm px-2">
      <div class="w-full bg-primary-800 p-6 rounded-lg border border-solid border-primary-200">
        <div v-if="!guardada" >
          <Input class="mb-2" id="newpwds" show-password placeholder="Nueva contraseña…" v-model="newpwd"/>
          <Input class="mb-4" id="newpwdsr" show-password placeholder="Repetir contraseña…" v-model="newpwd2"/>
          <Button @click="onReset()" class="w-full" type="primary">Guardar contraseña</Button>
        </div>
        <div>
          <p v-if="errorlen" class="text-sm mt-2 text-primary-100"><span style="color:red">* </span>Introduce una contraseña que contenga al menos 8 carácteres</p>
          <p v-if="errorpwddif" class="text-sm mt-2 text-primary-100"><span style="color:red">* </span>Las contraseñas introducidad son diferentes</p>
          <p v-if="errorguardar" class="text-sm mt-2 text-primary-100"><span style="color:red">* </span>Error al guardar la contraseña: {{ this.mensajeError }}</p>
          <p v-if="guardada" class="text-lg mt-2 text-primary-100">Contraseña restablecida!</p>
          <Button v-if="guardada" @click="Login()" class="w-full" type="primary">Ir al login</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Button } from 'element-ui'
import  resetPasswordEmail from '../utils/portalResetPasswordEmail'
export default {
  name: 'login',
  components: {
    Input,
    Button
  },
  data () {
    return {
      email: '',
      pwd: '',
      newpwd: '',
      newpwd2: '',
      remember: false,
      resetpwd: false,
      loading: false,
      newpwdscreen: false,
      errorguardar: false,
      errorpwddif: false,
      errorlen: false,
      mensajeError: '',
      guardada: false
    }
  },
  methods: {
    async Login () {
      localStorage.removeItem('token')
      this.$router.push({ name: 'login' })
    },
    async onReset () {
      try {
        if (!this.newpwd || !this.newpwd2 || this.newpwd !== this.newpwd2 || (this.newpwd && this.newpwd.length < 8)) {
          this.errorlen = (!this.newpwd || !this.newpwd2 || this.newpwd.length !== 8)
          this.errorpwddif = this.newpwd !== this.newpwd2
        } else {
          this.errorlen = false
          this.errorpwddif = false
          console.log('HASH:' + this.$route.query.hash)

          const { Estado, Mensaje } = await resetPasswordEmail(this.$route.query.hash, this.newpwd)
           console.log('aaa:' + this.$route.query.hash)
          if (Estado === 'KO' || !Estado) {
            if (Mensaje === 'Token caducado'){
              alert('Sesión Caducada, por favor, inicie sesión nuevamente')
              localStorage.removeItem('token')
              this.$router.push({ name: 'login' })
            }
            else{
              this.mensajeError = Mensaje
              this.errorguardar = true
            }
          } else {
            this.mensajeError = ''
            this.errorguardar = false
            this.guardada = true
          }
        }
      } catch (error) {
        console.log(error.response)
      }
    }
  }
}
</script>
